import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {ProductSummaryModel} from '../../../api/entity/productSummary.model';
import {ProductRetrocessionRuleModel} from './productRetrocessionRule.model';
import {ProductRetrocessionRetrocessionModel} from "./productRetrocessionRetrocession.model";

export class ProductRetrocessionModel extends WithoutSummaryModel {
    id: number;
    product: ProductSummaryModel;
    retrocessions: ProductRetrocessionRetrocessionModel[] = [];
}
